import Cookie from 'js-cookie';
import { DOMAIN, KORU_DASHBOARD_URL, SESSION_COOKIE_NAME } from '../../lib/config';
import { AUTH_ROUTES } from '../../lib/constants';

export const logout = (redirect?: string): void => {
  Cookie.remove(SESSION_COOKIE_NAME as string, {
    domain: DOMAIN,
    secure: true,
  });
  Cookie.remove(`${SESSION_COOKIE_NAME}-legacy`, {
    domain: DOMAIN,
    secure: true,
    path: '/',
  });
  window.location.assign(`${KORU_DASHBOARD_URL}/auto-logout?target=${window.location.origin + (redirect || AUTH_ROUTES.signIn)}`);
};

export const getSessionCookie = (): string | undefined => {
  return Cookie.get(SESSION_COOKIE_NAME as string);
};
